<div class="p-5">
	<p>{{ labels().ERROR_MESSAGE_PAGE ?? 'Oops, an error occurred.' }}</p>
	<a href="/" class="nav-top-link">
		<i>{{ labels().BACK_TO_HOME ?? 'Back to Home page' }}</i>
	</a>
</div>